// Generated by packages/glyph-decoder/scripts/generate-regular-atlases.ts.
// Source: data/regular-glyph-atlas (cleartype-rgb, black text on white).
// Do not edit manually; run `npm run generate:regular-atlases`.
export const RAW_GLYPHS = [
    {
        char: " ",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "!",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAZrsAZrsARLsARLsARIgAIogAIogAAAAAZrsAAAAAAAAA",
    },
    {
        char: "\"",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAALsiuyK7IrsiiACIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "#",
        width: 7,
        anchorKey: "HHJHhH\u0000",
        weightsB64: "AAAAAAAAAAAA/wAiuwAAIrsARIgA////////ZgCIRAC7IgAAuyIA/wAA////////ZiK7AESIAABmZgBmZgAAiEQAuyIAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "$",
        width: 7,
        anchorKey: "\u0000\u0010\u0222\u0222\u0222\u00c0\u0000",
        weightsB64: "AAAAAAAAAACI////AABmuyJmRIgAZmYiZgAAAET/ImYAAAAAAP///yIAAAAiZkT/AIhEImYA/yJEuyJmRLsAAGb///8AAAAAImYAAAAAAAAAAAAA",
    },
    {
        char: "%",
        width: 11,
        anchorKey: "\u0000\"\"\u0014\u0000\u0000\u0080\u0222\u0220\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAA//9mAAAi/wAAAGZmAP8iAIhEAAAAiEQAuyIiuwAAAABmZgD/IrtEAAAAAAD//2ZEiET//yIAAAAAALsiuyJEuwAAAABEiAD/ACK7AAAAALsiALsiRLsAAABmZgAARP//IgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "&",
        width: 8,
        anchorKey: "\u0000\u0000\u0232\u0222\u0000\u0180\u0200\u0000",
        weightsB64: "AAAAAAAAAAAAAP//iAAAAACIZgC7RAAAAIhmALtEAAAAIv+7iAAAAABm//8AAAAAZogAiLtEuwC7RAAAu/9EAGaIAACI/2YAAIj//4gA/yIAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "'",
        width: 2,
        anchorKey: "\u0000\u0000",
        weightsB64: "AAC7IrsiuwAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "(",
        width: 4,
        anchorKey: "\u0000\u0208\u0000\u0000",
        weightsB64: "AAAAAAAAuyIAZmYAAP8AAESIAABmZgAAiGYAAGZmAABEiAAAAP8AAABmZgAAALsi",
    },
    {
        char: ")",
        width: 4,
        anchorKey: "\u0000\u0000\u0110\u0000",
        weightsB64: "AAAAAGZmAAAAuyIAAESIAAAA/wAAALsiAAC7IgAAuyIAAP8AAESIAAC7IgBmZgAA",
    },
    {
        char: "*",
        width: 5,
        anchorKey: "\u0000\u0000\u0000\u0004\u0000",
        weightsB64: "AAAAAAAAIogAALuIiP8AAGa7AABEiESIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "+",
        width: 7,
        anchorKey: "\u0000     \u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEiAAAAAAARIgAAACI//////8iAABEiAAAAAAARIgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ",",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZogAAIgAIkQA",
    },
    {
        char: "-",
        width: 4,
        anchorKey: "@@@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA////RAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ".",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZogAAAAAAAAA",
    },
    {
        char: "/",
        width: 3,
        anchorKey: "\u0100\u0010\u0000",
        weightsB64: "AAAAACK7AGZmAIhEAP8AIrsAZmYAiEQA/wAAuwAAAAAAAAAA",
    },
    {
        char: "0",
        width: 7,
        anchorKey: "\u0000\u0104\u0202\u0202\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAABE//9mAAAi/wAAu0QARIgAAGaIAGZmAABEuwCIZgAARLsAZmYAAES7AESIAABmiAAi/yIAu0QAAET//2YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "1",
        width: 7,
        anchorKey: "\u0000\b\u0000\u0004\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAGaIAAAAAIj/iAAAAP+7ZogAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "2",
        width: 7,
        anchorKey: "\u0000\u0300\u0282\u0242\u0222\u0208\u0000",
        weightsB64: "AAAAAAAAAABm////AABEuwAAZrsAiEQAAAD/AAAAAABEuwAAAAAi/yIAAABE/yIAAABm/wAAAABm/wAAAAAAu///////AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "3",
        width: 7,
        anchorKey: "\u0000\u0000\u0202\u0222\u0000\u0080\u0000",
        weightsB64: "AAAAAAAAAACI//+IAABmiAAAu0QAAAAAAGaIAAAAAAC7RAAAAGb/uwAAAAAAAES7AAAAAAAA/wCIZgAARLsAALv//7sAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "4",
        width: 7,
        anchorKey: "\u0000\u0080\u0080\u0080\u03fe\u0080\u0000",
        weightsB64: "AAAAAAAAAAAAACL/AAAAAAC7/wAAAABmiP8AAAAiuyL/AAAAuyIi/wAAZmYAIv8AALv//////yIAAAAi/wAAAAAAIv8AAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "5",
        width: 7,
        anchorKey: "\u0000\u0014\u0212\u0212\u0012\u00c0\u0000",
        weightsB64: "AAAAAAAAAAC7////iAAA/wAAAAAAIrsAAAAAAET/////AABmuwAAIrsAAAAAAAD/AAAAAAAA/wCIZgAAIogAALv//7sAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "6",
        width: 7,
        anchorKey: "\u0000\u0124\u0212\u0212\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAi//+7AAAA/wAAiGYARIgAAAAAAGZm//+7AABm/wAAZmYAZmYAAES7AERmAABEuwAA/wAAZmYAAET//4gAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "7",
        width: 7,
        anchorKey: "\u0000\u0002\u0082\u0002\u0002\u0002\u0000",
        weightsB64: "AAAAAAAAALv//////wAAAAAAiGYAAAAARLsAAAAAALtEAAAAAES7AAAAAACIZgAAAAAA/yIAAAAAIrsAAAAAAES7AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "8",
        width: 7,
        anchorKey: "\u0000\u0000\u0222\u0222\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAABm//+IAABEuwAAu2YAZmYAAESIAES7AAC7ZgAARP//ZgAAZrsAAIiIAIhmAABEuwBmuwAAiIgAAIj//7sAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "9",
        width: 7,
        anchorKey: "\u0000$\u0242\u0242\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAABm//+IAABE/wAAu2YAZmYAAES7AGZmAABEuwBE/wAAu7sAAGb//0S7AAAAAABEiABEuwAAu0QAAIj//2YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ":",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZogAAAAAAAAAAAAAAAAAAAAAZogAAAAAAAAA",
    },
    {
        char: ";",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZogAAAAAAAAAAAAAAAAAAAAAZogAAIgAIkQA",
    },
    {
        char: "<",
        width: 7,
        anchorKey: "\u0000\u0000PP\u0000\u0088\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGb/AAAi//9mAACIuwAAAAAAACL//2YAAAAAAABm/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "=",
        width: 7,
        anchorKey: "\u0000\u0090\u0090\u0090\u0090\u0090\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIj//////wAAAAAAAAAAAAAAAAAAAIj//////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ">",
        width: 7,
        anchorKey: "\u0000\u0000PP\u0000 \u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAiLsAAAAAAAAi//9mAAAAAAAAZv8AACL//2YAAIi7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "?",
        width: 7,
        anchorKey: "\u0000\u0004\u0002B\"\b\u0000",
        weightsB64: "AAAAAAAAAABm////AABE/wAAZrsAiGYAAAD/AAAAAAAiuwAAAABE/yIAAAAi/wAAAAAAZogAAAAAAAAAAAAAAABmZgAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "@",
        width: 12,
        anchorKey: "\u0000\u0010\u0800\u0004\u0212\u0212\u0102\u0222\u0204\u0900\u0420\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAARP////9EAAAAAAC7/wAAAAD/iAAAAGaIAAAAAAAAu0QAIv8AAP//u4hERLsAZogAu0QARP8iIv8AiGZEuwAAIrsAIrsAiERmZgAARIgAZmYAZmZEuwAA/2ZE/wAARLsAiP//Zv//AAAAALtmAAAAAAAAIv8AACL/uwAAAABm/yIA",
    },
    {
        char: "A",
        width: 7,
        anchorKey: "\u0000@@@P\u0080\u0000",
        weightsB64: "AAAAAAAAAAAARLsAAAAAAIiIIgAAACK7RGYAAABmZgD/AAAAuyIAiEQAIv////+IAGZmAAAA/wC7AAAAAIhEiAAAAABEuwAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "B",
        width: 8,
        anchorKey: "\u0000\u0222\u0222\u0222\u0222\u0222\u00c0\u0000",
        weightsB64: "AAAAAAAAAABm//////8AAGaIAAAAZrsAZogAAAAiuwBmiAAAAGZmAGb//////2YAZogAAAAi/wBmiAAAAAD/AGaIAAAARLsAZv//////AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "C",
        width: 9,
        anchorKey: "\u0000\u0000\u0000\u0202\u0202\u0202\u0104\u0088\u0000",
        weightsB64: "AAAAAAAAAAAAAACI////ZgAAALuIAAAA/2YARLsAAAAAIv8AiGYAAAAAAAAAiEQAAAAAAAAAZmYAAAAAAAAARLsAAAAAIv8AALuIAAAA/2YAAACI////ZgAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "D",
        width: 9,
        anchorKey: "\u0000\u0202\u0202\u0202\u0202\u0202\u0104\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZv//////AAAAZogAAABE/wAAZogAAAAAZmYAZogAAAAARLsAZogAAAAAIrsAZogAAAAARLsAZogAAAAAiGYAZogAAABE/wAAZv//////AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "E",
        width: 8,
        anchorKey: "\u0000\u0222\u0222\u0222\u0222\u0222\u0200\u0000",
        weightsB64: "AAAAAAAAAABm//////+7AGaIAAAAAAAAZogAAAAAAABmiAAAAAAAAGb//////2YAZogAAAAAAABmiAAAAAAAAGaIAAAAAAAAZv///////wAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "F",
        width: 7,
        anchorKey: "\u0000\"\"\"\"\u0002\u0000",
        weightsB64: "AAAAAAAAAGb//////yJmiAAAAAAAZogAAAAAAGaIAAAAAABm/////0QAZogAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "G",
        width: 9,
        anchorKey: "\u0000\u0088\u0000\u0202\u0202\u0242D\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAACI////RAAAAIiIAAAi/yIAIv8AAAAAZmYAZogAAAAAAAAAZmYAAAAAAAAAZogAAGb//7sAIv8AAAAARLsAAIi7AAAAiLsAAABm////iAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "H",
        width: 9,
        anchorKey: "\u0000      \u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZv///////4gAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "I",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAZogAZogAZogAZogAZogAZogAZogAZogAZogAAAAAAAAA",
    },
    {
        char: "J",
        width: 6,
        anchorKey: "\u0000\u0200\u0200\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZogAAAAAZogAAAAAZogAAAAAZogAAAAAZogAAAAAZogAAAAAZogAuwAAiGYAiP//uwAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "K",
        width: 8,
        anchorKey: "\u0000@ 0H\u0004\u0202\u0000",
        weightsB64: "AAAAAAAAAABmiAAAACL/RGaIAAAi/wAAZogAIv8AAABmiCL/AAAAAGa7//9EAAAAZv8iRP8iAABmiAAAZrsAAGaIAAAAu2YAZogAAAAi/2YAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "L",
        width: 7,
        anchorKey: "\u0000\u0200\u0200\u0200\u0200\u0200\u0000",
        weightsB64: "AAAAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAZv//////RAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "M",
        width: 9,
        anchorKey: "\u0000\u0002\u0000\u0000\u0000\u0000\u0002\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZv9EAAAA/4gAZrtmAABEu4gAZoi7AABmiIgAZoiIAACIZogAZohmRCKIZogAZogiZkREZogAZogAu4giZogAZogAiLsAZogAZogAZogAZogAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "N",
        width: 9,
        anchorKey: "\u0000\u0006\u0000\u0010\u0000\u0000\u0100\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZv8AAAAAZogAZv+IAAAAZogAZoiIRAAAZogAZogA/wAAZogAZogARGYAZogAZogAALsiZogAZogAACK7ZogAZogAAABm/4gAZogAAAAAu4gAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "O",
        width: 9,
        anchorKey: "\u0000\u0000\u0000\u0202\u0202\u0202\u0104p\u0000",
        weightsB64: "AAAAAAAAAAAAAAC7////AAAAALtmAABE/yIARIgAAAAAZogAiGYAAAAAIv8AiEQAAAAAAP8AiEQAAAAAIv8ARIgAAAAAZogAALuIAABE/yIAAACI////AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "P",
        width: 8,
        anchorKey: "\u0000\"\"\"\"\"\b\u0000",
        weightsB64: "AAAAAAAAAABm//////8iAGaIAAAARLsAZogAAAAi/wBmiAAAAGa7AGb//////wAAZogAAAAAAABmiAAAAAAAAGaIAAAAAAAAZogAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Q",
        width: 9,
        anchorKey: "\u0000\u0004\u0000\u0202\u0202\u0102\u0104\u0200\u0000",
        weightsB64: "AAAAAAAAAAAAAAC7////AAAAAP9mAABE/wAAZogAAAAAiGYAiEQAAAAARLsAu0QAAAAAIrsAiEQAAAAARLsAZogAAGYAZmYAALtmAET//wAAAAC7//+IiP8iAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "R",
        width: 9,
        anchorKey: "\u0000\"\"\"\"\"\u0100\u0200\u0000",
        weightsB64: "AAAAAAAAAAAAZv//////iAAAZogAAAAAu2YAZogAAAAAZogAZogAAAAAu2YAZv//////ZgAAZogAAIi7AAAAZogAAAC7iAAAZogAAAAi/0QAZogAAAAAZv8iAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "S",
        width: 8,
        anchorKey: "\u0000\u0114\u0202\u0222\u0222\u0000\u0080\u0000",
        weightsB64: "AAAAAAAAAAAARP///4gAAET/AAAAu2YAZogAAABEuwAi/2YAAAAAAAAAiP//uwAAAAAAAABmuwCIRAAAAAD/AET/AAAARLsAAET///+7AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "T",
        width: 7,
        anchorKey: "\u0002\u0002\u0002\u0002\u0002\u0002\u0000",
        weightsB64: "AAAAAAAAAP///////2YAAGaIAAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "U",
        width: 9,
        anchorKey: "\u0000\u0100\u0200\u0200\u0200\u0200\u0100\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogAZogAAAAAZogARLsAAAAAZmYAAP9EAAAi/yIAAAD/////IgAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "V",
        width: 7,
        anchorKey: "\u0002\u0000\u0000\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAP8AAAAAZma7IgAAALsiZmYAACK7ACK7AABmZgAAuyIAuyIAAGZmIrsAAAAiiGZmAAAAALuIIgAAAABmuwAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "W",
        width: 11,
        anchorKey: "\u0002\u0000\u0200\u0000\u0000\u0002 \u0200\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAD/AAAAiP8AAACIRLsiAAC7iCIAALsiZmYAIrtmZgAiuwBEiABEZiKIAESIACK7AGZEAP8AZkQAALsAuwAAiCK7IgAAiES7AABmRLsAAABEu2YAACK7iAAAACL/RAAAAP9EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "X",
        width: 7,
        anchorKey: "\u0200\u0004\u0000 \u0080\u0002\u0000",
        weightsB64: "AAAAAAAAALtmAAAA/yIA/wAAZmYAAGZmIrsAAAAAu4giAAAAAGb/AAAAACK7ZmYAAACIRAD/IgBEiAAAZogA/yIAAAC7ZgAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Y",
        width: 7,
        anchorKey: "\u0002\b\u0000 \b\u0002\u0000",
        weightsB64: "AAAAAAAAAP9EAAAA/0RmuwAAZogAAP9EAP8iAABEu2ZmAAAAALv/AAAAAABmiAAAAAAAZogAAAAAAGaIAAAAAABmiAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Z",
        width: 7,
        anchorKey: "\u0200\u0282\u0242\u0202\u020a\u0202\u0000",
        weightsB64: "AAAAAAAAAIj//////yIAAAAAZrsAAAAAIv8iAAAAALtmAAAAAIiIAAAAAET/AAAAAAD/RAAAAACIZgAAAAAA////////RAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "[",
        width: 3,
        anchorKey: "\u0000\u0802\u0000",
        weightsB64: "AAAAiP9miEQAiEQAiEQAiEQAiEQAiEQAiEQAiEQAiEQAiP9m",
    },
    {
        char: "\\",
        width: 3,
        anchorKey: "\u0004@\u0000",
        weightsB64: "AAAAuwAA/wAAiEQAZmYAIrsAAP8AAIhEAGZmACK7AAAAAAAA",
    },
    {
        char: "]",
        width: 3,
        anchorKey: "\u0802\u0ffe\u0000",
        weightsB64: "AAAA//8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8AAP8A//8A",
    },
    {
        char: "^",
        width: 5,
        anchorKey: " \u0000\u0000 \u0000",
        weightsB64: "AAAAAAAAZogAAAC7uwAARIhmRACIRCKIAP8AAP8iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "_",
        width: 7,
        anchorKey: "\u0800\u0800\u0800\u0800\u0800\u0800\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///////+7",
    },
    {
        char: "`",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAAIiIAAAAuyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "a",
        width: 7,
        anchorKey: "\u0000\u0080\u0248\u0248H\u0200\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAGb///8AAES7AABmiAAAAAAARIgAAAD///+IAET/AABmiABmiAAAZrsAALv//4j/AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "b",
        width: 7,
        anchorKey: "\u0000\u03be\u0000\u0208\b\u00e0\u0000",
        weightsB64: "AAAAAAAAAAD/AAAAAAAA/wAAAAAAAP+I//8AAAD/ZgBmiAAA/wAAAP8AALsAAAD/AAD/AAAi/wAA/0QAZogAAP+I/7sAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "c",
        width: 6,
        anchorKey: "\u0000\u0110\u0208\u0208\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAET//7sAIv8AAIhmZogAAAAAZmYAAAAAZogAAAAAIv8AAGaIAET//7sAAAAAAAAAAAAAAAAA",
    },
    {
        char: "d",
        width: 7,
        anchorKey: "\u0000\u0110\u0208\u0208\u0000\u03fe\u0000",
        weightsB64: "AAAAAAAAAAAAAAAi/wAAAAAAIv8AAET//4j/AAD/IgCI/wBEiAAAIv8AZogAAAD/AESIAAAi/wAA/yIAiP8AACL//4j/AAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "e",
        width: 7,
        anchorKey: "\u0000\u0150\u0248\u0248@\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAET//4gAAAD/IgC7RABEuwAARIgARP////+7AESIAAAAAAAA/yIAiGYAAET//7sAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "f",
        width: 3,
        anchorKey: "\b\n\u0002",
        weightsB64: "AAAAACL//yJmiAAA//+7AGaIAABmiAAAZogAAGaIAABmiAAAZogAAAAAAAAAAAAA",
    },
    {
        char: "g",
        width: 7,
        anchorKey: "\u0000\u0910\u0a08\u0a08\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAET//4i7AAD/IgCIuwBEiAAAIrsAZmYAACK7AESIAAAiuwAA/yIAiLsAAET//2a7AAAAAABmiAAi////uwAA",
    },
    {
        char: "h",
        width: 7,
        anchorKey: "\u0000\u0010\b\b\b\u0000\u0000",
        weightsB64: "AAAAAAAAAGaIAAAAAABmiAAAAAAAZoj///8AAGb/IgCIZgBmiAAAZogAZogAAGaIAGaIAABmiABmiAAAZogAZogAAGaIAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "i",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAZogAAAAAZogAZogAZogAZogAZogAZogAZogAAAAAAAAA",
    },
    {
        char: "j",
        width: 3,
        anchorKey: "\u0800\u0000\u0000",
        weightsB64: "AAAAIrsAAAAAIrsAIrsAIrsAIrsAIrsAIrsAIrsARLsA/2YA",
    },
    {
        char: "k",
        width: 6,
        anchorKey: "\u0000@ \u0010\b\u0000",
        weightsB64: "AAAAAAAAIrsAAAAAIrsAAAAAIrsAIv9mIrsA/yIAIrv/IgAAIv9mZgAAIrsAuyIAIrsAIrsAIrsAAGaIAAAAAAAAAAAAAAAA",
    },
    {
        char: "l",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAZogAZogAZogAZogAZogAZogAZogAZogAZogAAAAAAAAA",
    },
    {
        char: "m",
        width: 11,
        anchorKey: "\u0000\u0010\u0000\b\b\u0010\u0000\b\b\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIruI//8iiP//IgAi/0QAZv9EAGaIACK7AAAiuwAARLsAIrsAACK7AABEuwAiuwAAIrsAAES7ACK7AAAiuwAARLsAIrsAACK7AABEuwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "n",
        width: 7,
        anchorKey: "\u0000\u0010\b\b\b\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAZmb///8AAGb/IgCIZgBmiAAAZogAZogAAGaIAGaIAABmiABmiAAAZogAZogAAGaIAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "o",
        width: 7,
        anchorKey: "\u0000\u0110\u0208\u0208\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAET//4gAAAD/IgCIZgBEiAAARLsAZogAACK7AESIAABEuwAA/yIAiGYAAET//4gAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "p",
        width: 7,
        anchorKey: "\u0000\u0130\u0000\u0208\u0000@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAARIi7/7sAAET/ZgCIiABE/wAAIrsARLsAAAD/AES7AAAiuwBE/0QAiGYARLu7/7sAAES7AAAAAABEuwAAAAAA",
    },
    {
        char: "q",
        width: 7,
        anchorKey: "\u0000\u0110\u0208\u0208\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAET//2a7ACL/IgC7uwBEiAAARLsAZmYAACK7AESIAABEuwAA/yIAu7sAAET//4i7AAAAAABEuwAAAAAARLsA",
    },
    {
        char: "r",
        width: 4,
        anchorKey: "\u0000\u0010\b\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAZoj/iGb/AABmiAAAZogAAGaIAABmiAAAZogAAAAAAAAAAAAA",
    },
    {
        char: "s",
        width: 7,
        anchorKey: "\u0000\u0200\u0248\u0248\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAIj//4gAAESIAAC7RABEuwAAAAAAAGb//7sAAAAAAACIZgCIZgAAiGYAAP///4gAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "t",
        width: 3,
        anchorKey: "\b\u0208\u0000",
        weightsB64: "AAAAZogAZogA//+IZogAZogAZogAZogAZogAIv+IAAAAAAAA",
    },
    {
        char: "u",
        width: 7,
        anchorKey: "\u0000\u0000\u0200\u0200\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAZogAAGaIAGaIAABmiABmiAAAZogAZogAAGaIAGaIAABmiABEuwAAu4gAALv//2aIAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "v",
        width: 5,
        anchorKey: "\u0000\u0000\u0100\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAZgAAIru7AABmZrsiALsiZmYiuwAiu2ZmAAC7/yIAAGa7AAAAAAAAAAAAAAAA",
    },
    {
        char: "w",
        width: 9,
        anchorKey: "\b\u0080\u0100\u0000\u0010\u0000\u0100\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/wAAZrsAAIhmuyIAu/8AALsiZmYAu4hEIrsARIhEiGaIRIgAAP9mRCK7iEQAAIj/IgC7/wAAAGa7AACIiAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "x",
        width: 5,
        anchorKey: "\u0208\u0080 \u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAA/yIAu0REiESIAAC7/yIAAGa7AAAA/4hEAGZmIrsA/wAAiGYAAAAAAAAAAAAA",
    },
    {
        char: "y",
        width: 5,
        anchorKey: "\b\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAA/wAAZmaIIgCIIkRmALsAIrtEZgAAu4giAABmuwAAACKIAAAAZkQAALu7AAAA",
    },
    {
        char: "z",
        width: 5,
        anchorKey: "\u0208\u0208\u0208\u0208\u0200",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAA/////0QAAAAiuwAAAAC7IgAAAGZmAAAAIrsAAAAAuyIAAAAA//////8iAAAAAAAAAAAAAAAA",
    },
    {
        char: "{",
        width: 4,
        anchorKey: "\u0000\u00a0\u0802\u0000",
        weightsB64: "AAAAAABm/0QAuyIAALsiAAC7IgAi/wAAuwAAACL/AAAAuyIAALsiAAC7IgAAZv9E",
    },
    {
        char: "|",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgA",
    },
    {
        char: "}",
        width: 4,
        anchorKey: "\u0802\u0000\u0000\u0000",
        weightsB64: "AAAAAP+7AAAAuyIAALsiAAC7IgAAiGYAAABmRACIZgAAuyIAALsiAAC7IgD/uwAA",
    },
    {
        char: "~",
        width: 7,
        anchorKey: "\u0000  @@\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAi//9EAGYiiAAA//9mAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
];
//# sourceMappingURL=glyph_atlas_black_on_white_rgb.js.map